import React from "react"
import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"

interface ConfirmationModalProps {
  show: boolean
  title: string
  content?: string | null
  onOK?: (() => void) | null
  onCancel?: (() => void) | null
  danger?: boolean
}

const ConfirmationModal = ({ show, title, content, onOK = () => {}, onCancel = () => {}, danger = false }: ConfirmationModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal centered show={show} onHide={onCancel ?? undefined} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>{t("common.confirmation.title." + title)}</Modal.Title>
      </Modal.Header>
      {content && <Modal.Body>{t("common.confirmation.content." + content)}</Modal.Body>}
      <Modal.Footer>
        <Button variant="secondary" className="btn-default-sm" onClick={onCancel ?? undefined}>
          {t("common.confirmation.button.cancel")}
        </Button>
        <Button variant={danger ? "danger" : "primary"} className="btn-default-sm" onClick={onOK ?? undefined}>
          {t("common.confirmation.button.ok")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
